import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
// Read at page load, before AuthCallback clears the hash, so the startup /auth/me check is skipped on Google return.
const OAUTH_RETURN = window.location.hash.includes("session_id=");

export function StoreProvider({ children }) {
  const [user, setUserState] = useState(null);
  const seq = useRef(0);
  const setUser = useCallback((u) => { seq.current += 1; setUserState(u); }, []);
  const [config, setConfig] = useState(null);
  const [cart, setCart] = useState({ items: [], quote: null });

  const refreshUser = useCallback(async () => {
    const mine = ++seq.current;
    try {
      const { data } = await api.get("/auth/me");
      if (mine === seq.current) setUserState(data);
    } catch {
      if (mine === seq.current) setUserState(false);
    }
  }, []);
  const refreshCart = useCallback(async () => {
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } catch {
      setCart({ items: [], quote: null });
    }
  }, []);

  useEffect(() => {
    api.get("/store/config").then((r) => setConfig(r.data)).catch(() => setConfig({ mode: "PRELAUNCH", socials: {} }));
    refreshCart();
    if (OAUTH_RETURN) return;
    refreshUser();
  }, [refreshUser, refreshCart]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
    refreshCart();
  };
  const cartCount = (cart.items || []).reduce((s, i) => s + i.qty, 0);
  return <Ctx.Provider value={{ user, setUser, refreshUser, config, cart, setCart, refreshCart, cartCount, logout }}>{children}</Ctx.Provider>;
}

export const useStore = () => useContext(Ctx);
